// extracted by mini-css-extract-plugin
export var backdropBlur = "_ca-0";
export var contentCard = "_ca-5";
export var frame = "_ca-2";
export var image = "_ca-4";
export var imagePane = "_ca-3";
export var modal = "_ca-1";